/**
 * Hook léger pour récupérer les alertes pastorales globales.
 * Utilisé par la Sidebar (badge rouge) et le widget Dashboard.
 */
import { useEffect, useState, useCallback } from "react";
import { presencesApi } from "../services/api";
import useAuth from "./useAuth";

export function usePresenceAlerts() {
  const { isAdmin, isAuthenticated, usingMock } = useAuth();
  const [data, setData] = useState({
    rouge: [], orange: [], jaune: [],
    total_alertes: 0, total_critiques: 0,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!isAuthenticated || !isAdmin || usingMock) return;
    setLoading(true);
    setError(null);
    try {
      const { data: res } = await presencesApi.alertes();
      setData(res);
    } catch (err) {
      // Silencieux : ce hook ne doit pas casser l'UI s'il échoue
      setError(err.response?.data?.detail || err.message);
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated, isAdmin, usingMock]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { ...data, loading, error, refresh };
}

export default usePresenceAlerts;
